import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { selectors } from '../redux'
import { router, routesPath } from '../router'

import Loader from './Loader'

interface GuestGuardType {
  children: React.ReactNode
}

// For routes that can only be accessed by unauthenticated users
function GuestGuard({ children }: GuestGuardType) {
  const isConnected = useSelector(selectors.auth.isConnected)
  const isLoading = useSelector(selectors.auth.isLoading)

  if (isConnected) {
    return <Navigate to={router(routesPath.declaration)} />
  }

  if (isLoading) {
    return <Loader />
  }

  return children
}

export default GuestGuard
